import { SwipeableDrawer as Swipeable } from "@mui/material";
import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const ProductsContainer = styled.div`
  width: 100%;
  padding: 32px;
  margin-top: 104px;
`;

export const PageTitle = styled.h1`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
`;

export const PageSubtitle = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 16px;
`;

export const ProductsContent = styled.div`
  width: 100%;
  background: ${color.White};
  border-radius: 8px;
  padding: 32px;
  min-height: 75vh;
`;
export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const FieldBusca = styled(materialUI.TextField)`
  width: calc(100% - 600px);
  .MuiOutlinedInput-adornedStart {
    padding-left: 0;
  }
  .MuiOutlinedInput-root {
    border-radius: 8px;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${color.gray300};
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${color.primary};
      }
    }
  }
`;

export const InputAdornment = styled(materialUI.InputAdornment)``;

export const IconButton = styled(materialUI.IconButton)``;

export const BtnLink = styled.button`
  width: 225px;
  height: 40px;
  background: #2d5bff;
  border-radius: 8px;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: ${color.White};
  text-transform: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  :hover {
    cursor: pointer;
  }

  .link-icon {
    margin-left: 8px;
  }
`;

export const BtnEV = styled.button`
  width: 225px;
  height: 40px;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: ${color.White};
  text-transform: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  :hover {
    cursor: pointer;
  }

  .link-icon {
    margin-left: 8px;
  }
`;

export const OnPress = styled.div`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  width: 40px;
  position: relative;
  cursor: pointer;

  :hover {
    background-color: ${color.ice};
  }
`;

export const FiltersCount = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${color.error};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ProductsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 350px));
  grid-gap: 32px;
  justify-content: space-between;
`;

export const ProductsListContainer = styled.div<{ isRefreshing?: boolean }>`
  opacity: ${({ isRefreshing }) => (isRefreshing ? 0.6 : 1)};
  transition: opacity 0.2s ease;
`;

export const RefreshingLabel = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f5f8ff;
  border: 1px solid #dbe5ff;
  color: #2d5bff;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
`;

export const SwipeableDrawer = styled(Swipeable)`
  .MuiDrawer-paperAnchorRight {
    width: 392px;
    border-radius: 8px 0px 0px 8px;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color.Mediumgrey};
    }
  }
`;

export const NotFoundText = styled.div`
  width: 100%;
  text-align: center;
  padding: 50px;
  font-size: 16px;
  color: #636368;
  font-family: Inter;
  position: absolute;
  left: 0;
`;
